// Funzione che crea il pdf con l'elenco di tutti gli encasings necessari per gradare una submission list
import {jsPDF} from "jspdf";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab = "        "
const space = " "

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}


const addFooters = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, {
      align: 'center'
    })
  }
}


function parseStringToNumber (string) {
  if (!string)
    return Number.MAX_SAFE_INTEGER
  const number_string = Number(string)
  if (isNaN(number_string))
    return Number.MAX_SAFE_INTEGER - 1
  else
    return number_string
}

function compare(e1, e2) {
  const e1IntegerName = parseStringToNumber(e1.name)
  const e2IntegerName = parseStringToNumber(e2.name)
  if (e1IntegerName < e2IntegerName)
    return -1
  if (e1IntegerName > e2IntegerName)
    return 1
  return 0
}




export const encasingsPDF = (encasings, submissionListId) => {

  const doc = new jsPDF({orientation: "portrait"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  var img = new Image()
  img.src = '/images/square.png'
  doc.addImage(img, 'png', 10, 1, 15, 15)
  doc.setFontSize(24)
  writeBoldText(doc, I18n.t('js.PDFGenerator.common.aigrading'), 28, 13)

  doc.line(10, 18, 200, 18, 'FD')

  doc.setFontSize(18)
  writeBoldText(doc, I18n.t('js.PDFGenerator.encasings.title') + submissionListId, 10, 30)

  var tableContent = []
  const sortedEncasings = encasings.sort(compare)
  for(const encasing of sortedEncasings) {
    tableContent.push(
      [
        encasing.description ? encasing.description : '',
        encasing.code,
        encasing.name ? encasing.name : '',
        encasing.quantity
      ]
    )
  }

  doc.autoTable({
    theme: 'plain',
    head: [[
      I18n.t('js.PDFGenerator.encasings.description'),
      I18n.t('js.PDFGenerator.encasings.code'),
      I18n.t('js.PDFGenerator.encasings.name'),
      I18n.t('js.PDFGenerator.encasings.quantity')]],
    body: tableContent,
    margin: {left: 10, right: 10 },
    startY: 50,
    headStyles: {
      font: 'Koruri-Bold',
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    bodyStyles:{
      font: 'Koruri-Regular',
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      align: 'center'
    },
    alternateRowStyles: {
      fillColor: [230, 230, 230]
    }
  })

  addFooters(doc)




  var pdfName= `Encasings_for_submission_list_${submissionListId}.pdf`
  doc.save(pdfName);
}
